var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 9.16666H18.2915C17.8748 4.95583 14.3215 1.66666 9.99984 1.66666C5.39734 1.66666 1.6665 5.3975 1.6665 10C1.6665 14.6025 5.39734 18.3333 9.99984 18.3333C14.3207 18.3333 17.874 15.0442 18.2915 10.8333H11.6665V13.3333L7.49984 10L11.6665 6.66666V9.16666Z",
    fill: "#D4D3D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitLogout);
export default __webpack_public_path__ + "static/media/exit_logout.343c1ffddccca08ea6db30dd3a76709c.svg";
export { ForwardRef as ReactComponent };